import { getErrorCode, getErrorResponse } from '../../../../../common/api/errors'
import { settlementErrorText } from '../../../../settlement'
import { OVERPAYMENT_CREATE_ERROR_LABEL } from '../../Overpayments/core/consts'

export interface ApiErrorBody {
  errorCode?: string
  errors?: Record<string, string>
}

/**
 * Бэкенд отдаёт машиночитаемый errorCode (CPAYMENT-1591), а general_error — английским текстом
 * доменного исключения. Оператору показываем текст по коду; errors остаётся фолбэком для ошибок
 * валидации полей.
 */
const ERROR_MESSAGE: Record<string, string> = {
  DISPUTE_ALREADY_OPEN: 'По этому тикету уже открыт диспут',
  DISPUTE_ALREADY_RESOLVED: 'Диспут уже закрыт — обновите список',
  DISPUTE_NOT_FOUND: 'Диспут не найден — обновите список',
  DISPUTE_REASON_INVALID: 'Причина недоступна — обновите список причин',
  TICKET_NOT_FOUND: 'Тикет не найден',
  TICKET_STATE_INVALID: 'Тикет уже вышел из статуса проверки чеков',
  TICKET_TRANSITION_FAILED: 'Не удалось перевести тикет — обратитесь к администратору',
  TICKET_HAS_OPEN_DISPUTE: 'По тикету открыт диспут: операции с чеками недоступны',
  PAYOUT_NOT_DISPUTABLE: 'По этой выплате нельзя открыть диспут: она не завершена или не закрывалась депозитами',
  CULPRIT_NOT_CANDIDATE: 'Виновником можно выбрать только оплаченный депозит этой выплаты',
}

export function buildDisputeErrorText(data?: ApiErrorBody, fallback = 'Не удалось выполнить действие'): string {
  // A payout dispute success also answers with the settlement's codes and the overpayment it creates.
  const code = data?.errorCode
  const byCode = code
    ? ERROR_MESSAGE[code] ?? (settlementErrorText(code, '') || OVERPAYMENT_CREATE_ERROR_LABEL[code])
    : undefined
  if (byCode) return byCode

  if (data?.errors?.general_error) return data.errors.general_error

  const first = data?.errors ? Object.entries(data.errors)[0] : undefined
  return first ? `${first[0]}: ${first[1]}` : fallback
}

// Перехватчик axios отклоняет промис самим error.response, поэтому код и поля лежат в e.data.
export function disputeErrorFromException(e: unknown, fallback: string): string {
  return buildDisputeErrorText(
    { errorCode: getErrorCode(e), errors: getErrorResponse<Record<string, string>>(e) ?? undefined },
    fallback
  )
}
